import { useContext, useState } from 'react';
import { ClickAwayListener } from '@mui/material';
import { DatePicker } from 'formik-mui-lab';
import { FormControl, FormLabel } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { LocalizationProvider } from '@mui/lab';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import AdapterDayjs from '@mui/lab/AdapterDayjs';
// Our Components
import { CardContext } from 'context/cards/cardContext';
import CategoryInput from '../CreateCard/CategoryInput';
// Utils and Helpers
import dayjs from 'helpers/dayjs';

const EditCardInfoForm = ({ onSubmit, setDidFormValuesChange }) => {
    const { card } = useContext(CardContext);
    const [isDatepickerOpen, setIsDatepickerOpen] = useState(false);

    const validationSchema = Yup.object().shape({
        autoLock: Yup.date()
            .typeError('Invalid date')
            .nullable()
            .test('autoLock', 'Invalid date', autoLock => {
                if (!autoLock) return true;
                if (dayjs(autoLock).isSame(card?.autoLock)) return true;
                if (dayjs(autoLock).isAfter(dayjs())) return true;
                return false;
            })
            .optional(),
        label: Yup.string().trim().max(100, 'Max 100 characters').required('Required'),
        memo: Yup.string().trim().max(255, 'Max 255 characters').optional()
    });

    return (
        <Formik initialValues={card} enableReinitialize={true} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ dirty, values }) => (
                <Form id="edit-card-info-form">
                    {setDidFormValuesChange(dirty)}
                    <FormControl fullWidth sx={{ marginBottom: '24px' }}>
                        <FormLabel className="card-input-label">Cardholder Name</FormLabel>
                        <Field component={TextField} variant="outlined" name="name" type="text" size="small" disabled />
                    </FormControl>
                    <ClickAwayListener onClickAway={() => setIsDatepickerOpen(false)}>
                        <FormControl fullWidth sx={{ marginBottom: '24px' }}>
                            <FormLabel className="card-input-label">Auto Lock Date</FormLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Field
                                    component={DatePicker}
                                    variant="outlined"
                                    name="autoLock"
                                    mask="__/__/____"
                                    minDate={dayjs().add(1, 'day')}
                                    closeOnSelect
                                    open={isDatepickerOpen}
                                    onAccept={() => setIsDatepickerOpen(false)}
                                    textField={{
                                        size: 'small',
                                        onClick: () => setIsDatepickerOpen(isDatepickerOpen => !isDatepickerOpen)
                                    }}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </ClickAwayListener>
                    <FormControl fullWidth sx={{ marginBottom: '24px' }}>
                        <FormLabel required className="card-input-label">
                            Choose a category
                        </FormLabel>
                        <CategoryInput variant="outlined" name="label" size="small" />
                    </FormControl>
                    <FormControl fullWidth>
                        <FormLabel className="card-input-label">Add a Memo (Optional)</FormLabel>
                        <Field
                            component={TextField}
                            name="memo"
                            multiline
                            rows={4}
                            size="small"
                            placeholder="Add additional information about this card"
                        />
                    </FormControl>
                </Form>
            )}
        </Formik>
    );
};

export default EditCardInfoForm;
